<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
/*import Landing from './components/Landing.vue'

export default {
  name: 'App',
  components: {
    Landing
  }
}*/
</script>

<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0px;
  padding: 0px;
}

body {
  padding: 0px;
  margin: 0px;
}
</style>
